import { createRoot } from 'react-dom/client';
import { captureWakymaDraft } from '@src/helpers/WakymaDraft';

import App from '@src/App';
import { initStorageType } from '@src/helpers/StorageHelper';
import '@src/i18n';
import '@src/styles/index.css';
import '@src/styles/App.css';
import { loadAppConfig } from '@src/config/application';
import api from '@src/api/axiosInstance';
import { initializeSentry } from '@src/config/sentry';
import PubSub from 'pubsub-js';
import { EVENT_TOPIC_FORCE_REFRESH_CHAT, EVENT_TOPIC_FORCE_REFRESH_CHAT_LIST, EVENT_TOPIC_CHAT_ASSIGNMENT } from '@src/Constants';

initStorageType();
captureWakymaDraft();

const domNode = document.getElementById('root');
const root = createRoot(domNode as Element);

const initializeApp = async () => {
	try {
		const config = await loadAppConfig();
		window.config = config;
		if(config.APP_ENV_NAME === 'cvparc-shadow') {
			document.title='CV Parc · Chat';
			let lastRevision:string|undefined;
			let lastMessageCount:number|undefined;
			let lastMediaRevision:number|undefined;
			let lastDeliveryRevision:number|undefined;
			let lastEditRevision:number|undefined;
			let lastHistoryRevision:number|undefined;
			let refreshing=false;
			const refreshSharedInbox=async()=>{
				if(refreshing || document.visibilityState==='hidden')return;
				refreshing=true;
				try {
					const {data}=await api.get('/shadow/status/',{timeout:8000});
					const revision=String(data.revision??data.messages);
					if(lastRevision!==revision || lastHistoryRevision!==(data.history_revision??0)){PubSub.publish(EVENT_TOPIC_FORCE_REFRESH_CHAT_LIST,true);PubSub.publish(EVENT_TOPIC_FORCE_REFRESH_CHAT,{shadowSync:true,messagesChanged:lastHistoryRevision!==(data.history_revision??0) || lastMessageCount!==data.messages || lastMediaRevision!==(data.media_revision??0) || lastDeliveryRevision!==(data.delivery_revision??0) || lastEditRevision!==(data.edit_revision??0)});}
					lastHistoryRevision=data.history_revision??0;
					lastEditRevision=data.edit_revision??0;
					lastDeliveryRevision=data.delivery_revision??0;
					lastRevision=revision;
					lastMessageCount=data.messages;
					lastMediaRevision=data.media_revision??0;
				} catch { /* Retry without clearing drafts or altering outbound safety. */ }
				finally {refreshing=false;}
			};
			setInterval(refreshSharedInbox,1000);
			window.addEventListener('focus',()=>void refreshSharedInbox());
			document.addEventListener('visibilitychange',()=>void refreshSharedInbox());
			api.interceptors.response.use(async(response)=>{
				if(response.config.url?.includes('/resolve') && response.config.method==='patch') {PubSub.publish(EVENT_TOPIC_FORCE_REFRESH_CHAT_LIST,true);PubSub.publish(EVENT_TOPIC_FORCE_REFRESH_CHAT,{shadowSync:true,messagesChanged:true});}
				if(response.config.url?.startsWith('/chat_assignment/') && ['patch','put'].includes(response.config.method||'')) {
					PubSub.publish(EVENT_TOPIC_FORCE_REFRESH_CHAT_LIST,true);PubSub.publish(EVENT_TOPIC_FORCE_REFRESH_CHAT,{shadowSync:true,messagesChanged:true});
				}
				return response;
			},(error)=>{if(error.response?.data?.sent===false)window.displayCustomError?.('No se ha enviado el mensaje. Revisa el aviso e inténtalo de nuevo cuando se haya resuelto.');return Promise.reject(error);});
		}

		// Update API base URL
		api.defaults.baseURL = config.API_BASE_URL;

		initializeSentry(config);

		root.render(<App />);
	} catch (error) {
		console.error(error);
	}
};

initializeApp();
